import { WorkAreas } from '@core/components'
import type { TokenProps } from 'common/types'
import type { FC } from 'react'

import css from './ProjectView.css'

type ProjectViewProps = TokenProps

export const ProjectView: FC<ProjectViewProps> = ({ getToken }) => {
  return (
    <div className={css.projectView}>
      <WorkAreas getToken={getToken} />
    </div>
  )
}
